import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IToastMessage, ToastModel, ToastType } from 'src/app/shared/models/toast.model';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private readonly _defaultTimeout = 5;
  $toastState = new BehaviorSubject<ToastModel>(new ToastModel(false));

  public show(toastMessage: IToastMessage) {
    if (toastMessage.seconds === undefined || toastMessage.seconds <= 0) {
      toastMessage.seconds = this._defaultTimeout;
    }

    const toast = new ToastModel(true, toastMessage);

    this.$toastState.next(toast);
    setTimeout(
      () => this.$toastState.next(new ToastModel(false))
      , toastMessage.seconds * 1000
    );
  }

  public showError(toastMessage: IToastMessage) {
    toastMessage.type = ToastType.Error;
    this.show(toastMessage);
  }

  public showInfo(toastMessage: IToastMessage) {
    toastMessage.type = ToastType.Info;
    this.show(toastMessage);
  }

  public showWarning(toastMessage: IToastMessage) {
    toastMessage.type = ToastType.Warning;
    this.show(toastMessage);
  }

  public showSuccess(toastMessage: IToastMessage) {
    toastMessage.type = ToastType.Success;
    this.show(toastMessage);
  }
}